import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { getStockRecipe } from 'services/stockRecipeServices';
import StockRecipeForm from 'forms/StockRecipeForm';
import { StockRecipe } from 'types/models/StockMovement';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedRecipe } = React.useContext(EditStockModuleContext);
  const [completeStockRecipe, setCompleteStockRecipe] = React.useState<StockRecipe | null>(null);

  React.useEffect(() => {
    if (!selectedRecipe) {
      history.replace('/private/stock/recipes');
      return;
    }

    let mounted = true;

    (async () => {
      const recipe = await getStockRecipe(selectedRecipe.id);

      if (!mounted) return;

      if (!recipe) {
        history.replace('/private/stock/recipes');
        return;
      }

      setCompleteStockRecipe(recipe);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedRecipe, history]);

  if (!selectedRecipe) return <></>;
  if (!completeStockRecipe) return <div>{t('loading')}</div>;

  return <StockRecipeForm recipe={completeStockRecipe} />;
};
